import { track } from '@bnnvara/analytics/src/track';
import { BaseButton } from '@bnnvara/buttons';
import { GridSpacer } from '@bnnvara/grids';
import { Heading, Text } from '@bnnvara/typography';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './styled';

export const MembershipFailure = ({ backUrl }) => (
  <S.Wrapper align="center">
    <Heading element="h2" variant="two" textTransform="none" textAlign="center">
      Je betaling is mislukt
    </Heading>
    <GridSpacer />
    <Text center>
      Helaas is het niet gelukt om je aan te melden. Wil je het nogmaals
      proberen?
    </Text>
    <GridSpacer />
    <Link href={backUrl} passHref scroll={false}>
      <BaseButton
        fullWidth
        type="link"
        onClick={() =>
          track(' lid-worden-mislukt', 'click', 'terug-naar-formulier')
        }
      >
        Terug naar het formulier
      </BaseButton>
    </Link>
  </S.Wrapper>
);
MembershipFailure.propTypes = {
  backUrl: PropTypes.string,
};
